import React from "react";

import { Badge } from "react-bootstrap";
import Select from "react-select";

import { Button } from "aible";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle, faTrash } from "@fortawesome/free-solid-svg-icons";

import AibleStep from "containers/CreateWizard/AibleStep";
import Transform from "containers/Dataset/Transform";

import TableLoader, { TableColumn, TableRow } from "components/Table/Table.js";
import { LineInput } from "components/Inputs/LineInput";

import IndeterminateCheckBox from "components/CreateWizard/Dataset/IndeterminateCheckBox";

import DatasetTile from "components/Tiles/DatasetTile";

import { getIsChangeColumnType } from "containers/Home/reducer";
import { isEnabled } from "utils/featureFlags";

import styles from "./style.module.css";

// Temporarily removing value replacement functionality since it's not supported on the Armen side.
const ENABLE_VALUE_REPLACEMENT = false;

export default class ChooseColumns extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showTable: props.blueprintId ? true : true,
      selectedField: undefined,
      showPriceColumn: props.priceColumn ? true : false,
      showSplitColumn: props.splitColumn ? true : false
    };
  }

  handleUpdateDatasetSelection(dataset) {
    const { updateSelection, updateOutcome } = this.props;

    updateOutcome(undefined);
    return updateSelection(dataset);
  }

  handleSelectField(field) {
    const { selectedField } = this.state;

    return this.setState({
      selectedField: selectedField ? (selectedField.label === field.label ? undefined : field) : field
    });
  }

  renderTable() {
    const {
      id,
      selectedDataset,
      selectedFields,
      fieldTypes,
      ignored,
      ignoredValue,
      isEditing,
      blueprintId,
      originalDataset,
      options,
      sensitive,
      columnDescription,
      columnDescriptionDataset,
      updateColumnDescription,
      updateColumnDescriptionDataset,
      updateSelectedFields,
      updateFieldTypes,
      updateIgnored,
      updateIsSensitive,
      isDataMode,
      isOverallSegment,
      isForecast,
      forecastTimeCol,
      isNext
    } = this.props;
    const { selectedField } = this.state;

    let headers = [
      "Include",
      "Dataset Field",
      "Type",
      (blueprintId && originalDataset && originalDataset.id) || true
        ? blueprintId === "new" || blueprintId === "academic"
          ? "Description"
          : "Blueprint Field"
        : "Warnings",
      "Ignored Values",
      "Is Sensitive"
    ].filter((f, i) => id === "new" || i !== 3);

    if (isDataMode) {
      headers = headers.filter((f) => f !== "Include");
    }

    if (isNext) {
      headers = headers.filter((f) => f !== "Include" && f !== "Ignored Values");
    }

    if (blueprintId === "academic") {
      headers = headers.filter((f) => f !== "Is Sensitive");
    }

    const sOptions = originalDataset
      ? Object.keys(originalDataset.fields)
          .filter(
            (f) =>
              selectedDataset.fields[f] === undefined &&
              selectedFields &&
              Object.keys(selectedFields).filter((s) => selectedFields[s] === f).length === 0
          )
          .map((f) => ({ value: f, label: f }))
      : [];

    const rows = Object.keys(selectedDataset.fields).map((fKey, index) => {
      const field = selectedDataset.fields[fKey];
      const isIgnored = ignored && ignored[field.label];

      const isOutcome = selectedDataset.outcome === field.label;

      const isForecastTimeCol = field.label === forecastTimeCol && isForecast;

      const data = [
        "",
        field.label,
        fieldTypes[field.label]
          ? fieldTypes[field.label]
          : field.type && field.type.length > 1
            ? field.type.charAt(0).toUpperCase() + field.type.slice(1)
            : field.type,
        field.warnings ? (field.warnings.length === 0 ? "" : field.warnings.length) : ""
      ];

      let isMatch =
        (originalDataset && originalDataset.fields && originalDataset.fields[fKey] !== undefined) ||
        selectedFields[fKey];

      let match =
        originalDataset && originalDataset.fields[fKey] !== undefined
          ? fKey
          : selectedFields[fKey]
            ? selectedFields[fKey]
            : undefined;

      const isSensitive = sensitive && (sensitive[field.label] === true || (match && sensitive[match] === true));

      Object.keys(selectedFields).forEach((k) => {
        if (selectedFields[k] && selectedFields[k].value && selectedFields[k].value.label) {
          if (selectedFields[k].found === fKey) {
            isMatch = true;
          }
          if (selectedFields[k].found === fKey) {
            match = selectedFields[k].value.value;
          }
        }
      });

      const isLocked = options && options["lock"] === true;

      const cDesc =
        columnDescription && columnDescription[fKey]
          ? columnDescription[fKey]
          : selectedDataset && selectedDataset.descriptions
            ? selectedDataset.descriptions[index]
            : undefined;

      let matchField = undefined;

      originalDataset &&
        originalDataset.fields &&
        match &&
        Object.keys(originalDataset.fields).forEach((f, i) => {
          if (f === match) {
            matchField = originalDataset.fields[f];
          }
        });

      const bDesc = matchField ? matchField.description : undefined;

      const disableIgnore = isLocked || ((isOutcome === true || isForecastTimeCol) && !isIgnored);

      return {
        row: (
          <TableRow
            key={index + "_" + (selectedField ? selectedField.label : "")}
            className={
              styles.fieldRow +
              " " +
              (selectedField && selectedField.label === field.label ? styles.selectedFieldRow : "") +
              " " +
              (isMatch && !isIgnored ? styles.matchRow : "")
            }
          >
            {isDataMode || isNext ? (
              <React.Fragment />
            ) : (
              <TableColumn onClick={disableIgnore ? () => {} : () => updateIgnored(field.label, !isIgnored)}>
                <div className={styles.ignoreHolder} style={{ opacity: disableIgnore === true ? 0.5 : 1 }}>
                  <IndeterminateCheckBox
                    checked={isIgnored === "SOME" ? undefined : !isIgnored}
                    indeterminate={isIgnored === "SOME" ? true : undefined}
                  />
                  {/* <input
                    type="checkbox"
                    checked={isIgnored === "SOME" ? undefined : !isIgnored}
                    indeterminate={isIgnored === "SOME" ? true : undefined}
                    onChange={() => {}}
                  /> */}
                </div>
              </TableColumn>
            )}
            <TableColumn>
              <a onClick={() => this.handleSelectField(field)}>{data[1]}</a>
              {isOutcome && <Badge className={styles.outcomeBadge}>{"Outcome"}</Badge>}
              {isMatch && <Badge className={styles.aibleBadge}>{"Match"}</Badge>}
              {cDesc && blueprintId !== "academic" && <div className={styles.desc}>{cDesc}</div>}
              {bDesc && blueprintId !== "academic" && <div className={styles.desc}>{bDesc}</div>}
            </TableColumn>
            <TableColumn>
              {(field.type === "number" || fieldTypes[field.label] !== undefined) &&
              !(isOutcome && isForecast) &&
              !isLocked &&
              !isDataMode &&
              !isOverallSegment &&
              getIsChangeColumnType() ? (
                <Select
                  options={[
                    { label: "Categorical", value: "Categorical" },
                    { label: "Number", value: "Number" }
                  ]}
                  value={{ label: data[2], value: data[2] }}
                  onChange={(val) => updateFieldTypes(data[1], val.value)}
                />
              ) : (
                data[2]
              )}
            </TableColumn>
            {id === "new" && (
              <TableColumn style={{ width: blueprintId === "new" ? "50%" : "auto" }}>
                {blueprintId === "new" || blueprintId === "academic" ? (
                  <LineInput
                    isBox
                    style={{ height: "50px", justifyContent: "flex-start" }}
                    placeholder="Add Description"
                    value={cDesc}
                    onChange={
                      blueprintId === "academic"
                        ? (value) => updateColumnDescriptionDataset(selectedDataset.id, index, fKey, value)
                        : (value) => updateColumnDescription(blueprintId, fKey, value)
                    }
                  />
                ) : blueprintId && originalDataset && originalDataset.id ? (
                  <div className={styles.colSelect}>
                    {isMatch && this.state[data[1]] !== true ? (
                      <a onClick={() => this.setState({ [data[1]]: true })}>{match}</a>
                    ) : (
                      <Select
                        options={sOptions}
                        isClearable
                        onChange={(val) =>
                          updateSelectedFields({
                            [data[1]]: val ? val.value : undefined
                          })
                        }
                      />
                    )}
                  </div>
                ) : (
                  <a onClick={() => this.handleSelectField(field)}>{data[3]}</a>
                )}
              </TableColumn>
            )}
            {!isNext && (
              <TableColumn>
                {ignoredValue &&
                ignoredValue[field.label] &&
                Object.keys(ignoredValue[field.label]).filter((m) => ignoredValue[field.label][m] === true).length !== 0
                  ? Object.keys(ignoredValue[field.label]).filter((m) => ignoredValue[field.label][m] === true).length +
                    " ignored values"
                  : ""}
              </TableColumn>
            )}
            {blueprintId === "academic" ? (
              <React.Fragment />
            ) : (
              <TableColumn
                onClick={
                  isEditing === true && !isOverallSegment ? () => updateIsSensitive(fKey, !isSensitive) : () => {}
                }
              >
                <div className={styles.ignoreHolder}>
                  <input
                    type="checkbox"
                    checked={isSensitive}
                    onChange={() => {}}
                    disabled={isEditing !== true || isOverallSegment}
                  />
                </div>
              </TableColumn>
            )}
          </TableRow>
        ),
        data: data
      };
    });

    return selectedDataset && selectedDataset.fields ? (
      <div className={styles.table} style={{ width: selectedField ? "60%" : "100%" }}>
        <TableLoader headers={headers} rows={rows} minHeight={"240px"} />
      </div>
    ) : (
      <div />
    );
  }

  renderValueReplace(v, index) {
    const { editValueReplace } = this.props;

    return (
      <div className={styles.vReplace} key={index}>
        <LineInput
          isMediumBox
          placeholder="From"
          defaultValue={v.from}
          onChange={(val) => editValueReplace(v.id, "from", val)}
          style={{ marginRight: "10px" }}
        />
        <LineInput
          isMediumBox
          placeholder="To"
          defaultValue={v.to}
          onChange={(val) => editValueReplace(v.id, "to", val)}
          style={{ marginRight: "10px" }}
        />
        <Button type="secondary" onClick={() => editValueReplace(v.id, "delete", true)}>
          <FontAwesomeIcon icon={faTrash} />
        </Button>
      </div>
    );
  }

  renderValueTable() {
    const {
      ignoredValue,
      updateIgnoredValue,
      addValueReplace,
      valueReplace,
      options,
      isDataMode,
      isOverallSegment,
      bulkUpdateIgnoredValues,
      isNext
    } = this.props;
    const { selectedField } = this.state;

    const hasWarnings = selectedField && selectedField.warnings && selectedField.warnings.length > 0;
    const isNumber = selectedField && selectedField.min !== undefined;
    const isCategory = !isNumber && selectedField && selectedField.data;

    let headers = isCategory ? ["Include", "Value", "Count"] : isNumber ? ["Field", "Min", "Max"] : [];

    if (isDataMode || isNext) {
      headers = headers.filter((f) => f !== "Include");
    }

    const allValuesIncluded =
      selectedField &&
      ignoredValue &&
      ignoredValue[selectedField.label] &&
      Object.values(ignoredValue[selectedField.label]).filter((val) => val === true).length > 0
        ? false
        : true;

    const selectAll = () => {
      bulkUpdateIgnoredValues(selectedField.label, selectedField.data, allValuesIncluded);
    };

    const rows = isCategory
      ? selectedField.data.map((value, index) => {
          const isIgnored =
            ignoredValue && ignoredValue[selectedField.label] && ignoredValue[selectedField.label][value.value];

          return {
            data: [value.value, value.count],
            row: (
              <TableRow className={styles.fieldRow} key={index} style={{ opacity: isIgnored === true ? 0.5 : 1.0 }}>
                {isDataMode || isNext ? (
                  ""
                ) : (
                  <TableColumn>
                    <div className={styles.ignoreHolder}>
                      <IndeterminateCheckBox
                        checked={isIgnored === "SOME" ? undefined : !isIgnored}
                        indeterminate={isIgnored === "SOME" ? true : undefined}
                        onChange={
                          options && options["lock"] === true
                            ? () => {}
                            : () => updateIgnoredValue(selectedField.label, value.value, !isIgnored)
                        }
                      />
                      {/* <input
                        type="checkbox"
                        checked={isIgnored === "SOME" ? undefined : !isIgnored}
                        indeterminate={isIgnored === "SOME" ? true : undefined}
                        onChange={
                          options && options["lock"] === true
                            ? () => {}
                            : () =>
                                updateIgnoredValue(
                                  selectedField.label,
                                  value.value,
                                  !isIgnored
                                )
                        }
                      /> */}
                    </div>
                  </TableColumn>
                )}
                <TableColumn>{value.value}</TableColumn>
                <TableColumn>{value.count}</TableColumn>
              </TableRow>
            )
          };
        })
      : isNumber
        ? [
            {
              data: [selectedField.label, selectedField.min, selectedField.max],
              row: (
                <TableRow key={0}>
                  <TableColumn>{selectedField.label}</TableColumn>
                  <TableColumn>{selectedField.min}</TableColumn>
                  <TableColumn>{selectedField.max}</TableColumn>
                </TableRow>
              )
            }
          ]
        : [];

    return (
      <div
        className={styles.valueTable}
        style={{
          width: selectedField ? "calc(40% - 10px)" : "0%",
          marginLeft: selectedField ? "10px" : "0px"
        }}
      >
        <div
          className={styles.vHolder}
          style={{
            maxHeight: hasWarnings ? "250px" : "500px"
          }}
        >
          {isCategory || isNumber ? (
            <TableLoader
              headers={headers}
              rows={rows}
              paddingBottom={250}
              label={selectedField ? selectedField.label : undefined}
              selectAllOption={selectedField && isCategory && true && !isNext}
              allValuesIncluded={allValuesIncluded}
              selectAll={selectAll}
            />
          ) : (
            <div />
          )}
        </div>
        {ENABLE_VALUE_REPLACEMENT && !isDataMode && selectedField && isCategory && (
          <div className={styles.valueReplace}>
            <Button type="secondary" onClick={() => addValueReplace(selectedField.label)} disabled={isOverallSegment}>
              {"Add Value Replace"}
            </Button>
            {valueReplace &&
              Object.keys(valueReplace)
                .filter((v) => valueReplace[v].column === selectedField.label && valueReplace[v].delete !== true)
                .map((v) => valueReplace[v])
                .map((v, index) => this.renderValueReplace(v, index))}
          </div>
        )}
        {hasWarnings ? (
          <div className={styles.warningHolder}>
            {selectedField.warnings.map((w, index) => (
              <div className={styles.warning} key={index}>
                <div className={styles.warningIcon}>
                  <FontAwesomeIcon icon={faExclamationTriangle} />
                </div>
                <div className={styles.warningText}>{w.message}</div>
              </div>
            ))}
          </div>
        ) : (
          <div />
        )}
      </div>
    );
  }

  renderSelectedDataset(selectedDataset) {
    const { blueprintId, isForecast } = this.props;
    const { showTable } = this.state;

    return (
      <div className={styles.dFlex}>
        <div className={styles.dSection}>
          <div className={styles.dMsg}>{"Dataset Selected"}</div>
          {<DatasetTile dataset={selectedDataset} />}
          <div className={blueprintId && blueprintId === "new" ? styles.changeDataset : styles.changeDatasetB}>
            <Button type="secondary" onClick={() => this.handleUpdateDatasetSelection({ value: undefined })}>
              {"Change"}
            </Button>
            {blueprintId === undefined && (
              <div className={styles.toggleHolder}>
                <Button type="secondary" onClick={() => this.setState({ showTable: !showTable })}>
                  {showTable ? "Hide Details" : "Show Details"}
                </Button>
              </div>
            )}
          </div>
          {isForecast && <div className={styles.forecastMsg}>{"This will be treated as a Forecasting run"}</div>}
        </div>
      </div>
    );
  }

  renderPriceColumn() {
    const { isEditing, selectedDataset, updatePriceColumn, priceColumn, options } = this.props;
    const { showPriceColumn } = this.state;

    const isLocked = options && options["lock"];

    const hasPriceColumn =
      showPriceColumn === true || (selectedDataset && selectedDataset.fields && selectedDataset.fields[priceColumn]);

    return (
      <div className={styles.priceColumn}>
        {isLocked ? (
          <div />
        ) : hasPriceColumn ? (
          <a
            onClick={() => {
              this.setState({ showPriceColumn: false });
              updatePriceColumn(undefined);
            }}
          >
            {"Remove True Positive Impact Column"}
          </a>
        ) : isEditing === true ? (
          <a onClick={() => this.setState({ showPriceColumn: true })}>{"Select True Positive Impact Column"}</a>
        ) : (
          <div />
        )}
        {hasPriceColumn && (
          <Select
            options={Object.keys(selectedDataset.fields)
              .filter((f) => selectedDataset.fields[f].type === "number")
              .map((f) => ({
                label: f,
                value: f
              }))}
            onChange={(val) => updatePriceColumn(val.value)}
            menuPlacement="top"
            value={
              priceColumn && selectedDataset.fields[priceColumn]
                ? { label: priceColumn, value: priceColumn }
                : undefined
            }
          />
        )}
      </div>
    );
  }

  render() {
    const {
      id,
      isShow,
      blueprintId,
      selectedDataset,
      ignored,
      updateStep,
      index,
      ignoredValue,
      options,
      isCalculated,
      isContinuous,
      isDataMode,
      isNext
    } = this.props;
    const { selectedField, showTable } = this.state;

    /*
    if(blueprintId !== undefined) {
      return <div />;
    }
    */

    if (selectedDataset === undefined || ignored === undefined) {
      return <div className={styles.emptyMsg}>{"Dataset not selected"}</div>;
    }

    if (isCalculated) {
      return (
        <div style={{ marginBottom: "20px" }}>
          <AibleStep
            id={id}
            blueprintId={blueprintId}
            bId={"calculatedFields"}
            message={"Would you like to create any calculated fields?"}
            secondaryMessage={"Click the + below to manually add a field"}
          />
          <Transform id={selectedDataset.id} setupId={id} options={options} />
        </div>
      );
    }

    return (
      <div className={styles.body} style={{ opacity: isShow === true ? 1 : 0 }}>
        {!isNext && (
          <AibleStep
            id={id}
            blueprintId={blueprintId}
            bId={"chooseColumns"}
            message={
              isDataMode
                ? "These are the columns and values in your data"
                : "Would you like the AI to ignore any fields?"
            }
            secondaryMessage={
              isDataMode
                ? undefined
                : "This does not change your data, the AI will only train using the selected fields"
            }
          />
        )}
        <div className={styles.tables} style={selectedDataset ? { paddingTop: "20px" } : {}}>
          {showTable && this.renderTable()}
          {showTable && this.renderValueTable()}
        </div>
      </div>
    );
  }
}
